import { QueryClient } from '@tanstack/react-query';

/**
 * Shared TanStack Query client for the whole application.
 * Centralizes default server-state behavior (stale time, gc time,
 * refetch policies, retries) used by every query/mutation hook.
 */
export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 30 * 1000,
            gcTime: 5 * 60 * 1000,
            refetchOnWindowFocus: false,
            retry: 1,
        },
        mutations: {
            retry: 0,
        },
    },
});

export default queryClient;
